module.exports = __webpack_public_path__ + "media/images/country_flags/ca-64aa0fcd9be1a93aaa75e81cead85700.png";